import React, { useEffect, useState } from 'react';
import { useItemStyles } from '../../hooks/useItemStyles';
import { EditorItem, useEditorStore } from '../../store/editorStore';

type TextItemContentProps = {
  item: EditorItem;
  isEditing: boolean;
};

export function TextItemContent({ item, isEditing }: TextItemContentProps) {
  const updateItem = useEditorStore((state) => state.updateItem);
  const [editText, setEditText] = useState(item.content);
  const { createContainerStyle, createTextareaStyle, createTextStyle } = useItemStyles();
  
  // Cập nhật editText khi item.content thay đổi
  useEffect(() => {
    setEditText(item.content);
  }, [item.content]);
  
  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setEditText(e.target.value);
  };

  const handleTextBlur = () => {
    updateItem(item.id, { content: editText });
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      handleTextBlur();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setEditText(item.content); // Reset về giá trị ban đầu khi hủy
    }
  };
  
  const style = item.style as any;
  const containerStyle = createContainerStyle(style);
  const textareaStyle = createTextareaStyle(style); 
  const textStyle = createTextStyle(style);
  
  // Xử lý hiển thị viền text trên giao diện
  // Lưu ý: Đây là CSS, không phải ffmpeg, nên cài đặt sẽ khác
  const textShadow = style.textOutlineWidth && style.textOutlineWidth > 0
    ? `0 0 ${style.textOutlineWidth}px ${style.textOutlineColor || '#000'}`
    : 'none';
  
  // Xử lý hiển thị viền ô chứa
  const borderStyle = style.borderWidth && style.borderWidth > 0
    ? `${style.borderWidth}px solid ${style.borderColor || '#000'}`
    : 'none';
  
  if (isEditing) {
    return (
      <div style={containerStyle}>
        <textarea
          value={editText}
          onChange={handleTextChange}
          onBlur={handleTextBlur}
          onKeyDown={handleKeyDown}
          style={textareaStyle}
          autoFocus
        />
      </div>
    );
  } 
  
  return (
    <div style={containerStyle}>
      <div style={textStyle}>
        {item.content}
      </div>
    </div>
  );
} 